import 'react-toastify/dist/ReactToastify.css';
import './app.scss';
import 'app/config/dayjs';

import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { getProfile } from 'app/shared/reducers/application-profile';
import { setLocale } from 'app/shared/reducers/locale';
import Header from 'app/shared/layoutnew/header/header';
import Footer from 'app/shared/layoutnew/footer/footer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { AUTHORITIES } from 'app/config/constants';
import AppRoutes from 'app/routes';
import ComponentWrapper from './views/user_profile/login/ComponentWrapper';
import Cookies from 'js-cookie';
import TermsModal from './shared/modal/TermsModal';
import { acceptTerms, updateEntity } from './entities/user-profile/user-profile.reducer';
const baseHref = document.querySelector('base').getAttribute('href').replace(/\/$/, '');

const _headers = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': 'Cookie',
};

export const App = () => {
  const [showTermsModal, setShowTermsModal] = React.useState(false);
  const [accepted, setAccepted] = React.useState(false);
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => state.authentication.account);
  const profile = useAppSelector(state => state.userProfile.entity);

  const profileData = React.useMemo(() => {
    if (Array.isArray(profile)) return profile[0];
    if (profile?.[0]) return profile[0];
    return profile;
  }, [dispatch, profile]);

  const userName = user.firstName + ' ' + user.lastName;

  Cookies.set('userName', userName, { secure: true, sameSite: 'None', domain: '.5plus.us' });

  // useEffect(() => {
  //   if (localStorage.getItem('access_token') !== null) {
  //     dispatch(getSession());
  //     dispatch(getProfile());
  //   }
  // }, []);

  const currentLocale = useAppSelector(state => state.locale.currentLocale);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account?.authorities, [AUTHORITIES.ADMIN]));
  const ribbonEnv = useAppSelector(state => state.applicationProfile.ribbonEnv);
  const isInProduction = useAppSelector(state => state.applicationProfile.inProduction);
  const isOpenAPIEnabled = useAppSelector(state => state.applicationProfile.isOpenAPIEnabled);
  const hasShownModal = React.useRef(false);

  useEffect(() => {
    if (hasShownModal.current) return;
    if (!profileData || !profileData.id) return;
    if (profileData.termsAccepted !== true) {
      setShowTermsModal(true);
      hasShownModal.current = true;
    }
  }, [profileData]);

  const handleAccept = async () => {
    const res = await dispatch(acceptTerms({ id: user.id }));
    if (acceptTerms.fulfilled.match(res)) {
      setShowTermsModal(false);
    }
  };

  const paddingTop = '60px';
  return (
    <BrowserRouter basename={baseHref}>
      <div className="app-container" style={{ paddingTop }}>
        {/* <ToastContainer position={toast.POSITION.TOP_LEFT} className="toastify-container" toastClassName="toastify-toast" /> */}
        <ErrorBoundary>
          <Header
            isAuthenticated={isAuthenticated}
            isAdmin={isAdmin}
            currentLocale={currentLocale}
            ribbonEnv={ribbonEnv}
            isInProduction={isInProduction}
            isOpenAPIEnabled={isOpenAPIEnabled}
          />
        </ErrorBoundary>
        <div className="container-fluid view-container" id="app-view-container">
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        </div>
        <Footer />
        <TermsModal
          isOpen={showTermsModal}
          toggle={() => {}}
          onAccept={handleAccept}
          accepted={accepted}
          setAccepted={setAccepted}
          showCancel={false}
        />
      </div>
    </BrowserRouter>
  );
};

export default App;
